import type { ComponentType } from "react";
import type { MaterialManifest } from "../web/material-manifest";

async function loadDefault(
  componentLoader: () => Promise<{ default: ComponentType<any> }>,
) {
  const componentModule = await componentLoader();
  return { component: componentModule.default };
}

export const h5MaterialManifest: MaterialManifest = {
  Button: () => loadDefault(() => import("./components/Button")),
  Container: () => loadDefault(() => import("./components/Container")),
  Image: () => loadDefault(() => import("./components/Image")),
};
